import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { Element, scroller } from 'react-scroll';
import Slider from "react-slick";
import HTML5Player from '../components/HTML5Player';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Play from '../components/icons/Play';
import Pause from '../components/icons/Pause';
import { Section, Heading, LineHeading, StyledVideoPlayer, ModalWrapper, ModalBox, StyledClose, SliderWrapper, StyledNextArrow, StyledPrevArrow } from './MusicAppreciation';
import { timestemp, mode, unsupported, dataLayer } from '../App';

const urlParams = new URLSearchParams(window.location.search);
const celebrityId = parseInt(urlParams.get('id'));


const settings = {
  slidesToShow: 4,
  className: "center",
  nextArrow: <StyledNextArrow />,
  prevArrow: <StyledPrevArrow />,
  infinite: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        className: "center",
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 500,
        arrows: false
      }
    }
  ]
};

export const Wrapper = styled.div`
  @media only screen and (min-width: 700px) {
    background-image: url(${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2_d.jpg);
    background-size: cover;
    background-attachment: fixed;
    }
`;

export const StyledSection = styled(Section)`
  position: relative;
  width: 100%;
  overflow: hidden;
  display: block;

  @media only screen and (min-width: 700px) {
    background-image: none;
  }
`;

const StyledHeading = styled(Heading)`
  font-size: 20px;
  padding-bottom: 0;

  @media only screen and (min-width: 700px) {
    font-size: 32px;
    text-align: center;
  }
`;

export const StyledLeftHeading = styled(StyledHeading)`
  font-size: 16px;
  text-align: left;
  padding: 16px 16px 8px;
  box-sizing: border-box;


  @media only screen and (min-width: 700px) {
    font-size: 32px;
    text-align: center;
  }
`

const StyledLineHeading = styled(LineHeading)`
  font-size: 16px;
  padding-top: 4px;
  width: calc(100% - 32px);
  max-width: 1000px;
  margin: auto;

  &:before, &:after{
    height: 3px;
  }


  @media only screen and (min-width: 700px) {
    font-size: 32px;
    text-align: center;
  }
`;

const InfoBox = styled.div`
  width: 100%;
  line-height: 1.5;
  color: white;
`;

const Remark = styled.div`
  text-align: center;
  padding-bottom: 30px;
`;

export const SongWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: auto;
  box-sizing: border-box;
  padding: 8px 16px;
`;

export const SongRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;


  @media only screen and (min-width: 700px) {
    & > img {
      width: 112px;
    }
  }
`;

export const SongInfo = styled.div`
  padding-left: 24px;
  width: calc(100% - 100px);
  color: white;

  .album-info {
    padding-top: 4px;
    font-size: 12px;
  }

  @media only screen and (min-width: 700px) {
    font-size: 20px;

    .album-info {
      font-size: 20px;
    }
  }
`;

export const OtherCelebrityAvatarWrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  white-space: nowrap;
  width: 100%;
  position: relative;
  overflow: auto;
`;

export const OtherCelebrityAvatar = styled.a`
  display: inline-block;
  text-decoration: none;
  vertical-align: top;
  color: black;
  font-size: 16px;
  padding: 0 8px;

  .avatar-bg {
    position: relative;
    background-image: url(${process.env.REACT_APP_BUILD_URL}/images/site/bubble_artist1.png);
    background-size: contain;
    background-repeat: no-repeat;
    padding: 8px;
    box-sizing: border-box;
    margin: auto;

    img {
      border-radius: 250px;
    }

    @media only screen and (min-width: 768px) {
      padding: 12px;
      background-size: contain;

      .name, .info {
        font-size: 16px;
      }
    }
  }
`;

export const GuidePlayer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1000px;
  margin: auto;

  .top-deco {
    position: absolute;
    top: -25px;
    left: 44px;

    @media only screen and (min-width: 737px) {
      left: 42px;
      width: 92%;
    }

    @media only screen and (min-width: 736px) {
      top: -48px;
    }

    @media only screen and (min-width: 768px) {
      top: -46px;
    }

    @media only screen and (min-width: 1024px) {
      top: -60px;
    }
  }

  @media only screen and (min-width: 737px) {
    margin-top: 40px;
  }
`;

export const GridBottomDecoWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 12.5vh;
`;

export const GridBottomDeco = styled.div`
  position: relative;
  height: 25vh;

  &:before {
    position: absolute;
    left: 0;
    bottom: 12.5vh;
    display: block;
    width: 100%;
    height: 100%;
    content: ' ';
    background-color: ${props => props.theme.colors.player};
    transform: skew(-80deg);

    @media only screen and (min-width: 700px) {
      transform: skew(-88deg);
    }
  }
`;

export const GuideBox = styled.div`
  position: relative;
  z-index: 10;
`;

export const GuideInfo = styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.player};
  display: flex;
  align-items: center;
  padding: 20px;
  border-top-left-radius: 36px;

  @media only screen and (min-width: 700px) {
    padding: 50px;
  }
`;

export const GuideInfoContent = styled.div`
  position: relative;
  font-size: 16px;
  max-width: calc(100% - 150px);

  .guide-album-info {
    padding-top: 8px;
    font-size: 14px;
    width: 100%;
  }

  @media only screen and (min-width: 700px) {
    font-size: 22px;
    width: calc(100% - 250px);

    .guide-album-info {
      font-size: 20px;
    }
  }
`;

export const GuideAvatar = styled.div`
  position: relative;
  width: 114px;
  margin-right: 16px;

  &::before {
    content: ' ';
    display: block;
    padding-top: 100%;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media only screen and (min-width: 700px) {
    width: 200px;
  }
`;

export const GuideAvatarRemark = styled.div`
    /* position: absolute;
    bottom: 15px;
    left: 145px; */
    font-size: 14px;

    span {
      font-weight: bold;
      color: ${props => props.theme.colors.primary};
    }

    @media only screen and (min-width: 700px) {
      left: 268px;
      bottom: 56px;
    }
`;

export const GuidePlay = styled.div`
  position: absolute;
  right: 24px;
  top: 40px;
  margin-top: -12px;

  @media only screen and (min-width: 700px) {
    top: 50%;
  }
`;

const StyledHTML5Player = styled(HTML5Player)`
  display: block;
`;

export const QuoteWrapper = styled.div`
  position: relative;
  color: white;
  padding: 0 24px;
  padding-top: 32px;
  text-align: center;
  max-width: 1000px;
  margin: auto;

  &:before {
    position: absolute;
    top: 0;
    left: 16px;
    background-image: url(${process.env.REACT_APP_BUILD_URL}/images/site/player/quote.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    content: ' ';
    width: 21px;
    height: 32px;

    @media only screen and (min-width: 700px) {
      width: 48px;
    }
  }

  &:after {
    position: absolute;
    top: 16px;
    right: 16px;
    content: ' ';
    height: 3px;
    width: calc(100% - 60px);
    background-color: ${props => props.theme.colors.primary};

    @media only screen and (min-width: 700px) {
      width: calc(100% - 100px);
    }
  }

  @media only screen and (min-width: 700px) {
    font-size: 24px;
  }
`;

export const AvatarInfo = styled.div`
  width: 100%;
  font-size: 12px;
  text-align: center;

  .name {
    color: ${props => props.theme.colors.primary};
  }

  .info {
    color: white;
  }

  @media only screen and (min-width: 700px) {
    font-size: 24px;
  }
`;

export const StyledPause = styled(Pause)`
  cursor: pointer;
  svg {
    width: 20px;
    fill: ${props => props.theme.colors.primary};

    @media only screen and (min-width: 700px) {
      width: 30px;
    }
  }
`;

export const StyledPlay = styled(Play)`
  cursor: pointer;
  svg {
    width: 20px;
    fill: ${props => props.theme.colors.primary};
  
    @media only screen and (min-width: 700px) {
      width: 30px;
    }
  }
`;

export const StyledSliderWrapper = styled(SliderWrapper)`

  @media only screen and (min-width: 768px) {
    max-width: 1000px;
  }
`;

const StyledFullVideoPlayer = styled(StyledVideoPlayer)`
  width: 100%;
`;

/* Modal */
const ModalHeading = styled.h2`
  color: black;
`;

const ModalContent = styled.div`
  font-size: 16px;
`;

export const PlayingLabel = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.primary};
  white-space: nowrap;
`;

const getData = async () => {
  let data = [];
  try {
    const response = await axios.get(`${process.env.REACT_APP_BUILD_URL}/data${mode !== 'production' ? '.uat' : ''}.json?t=${timestemp}`);
    if(response.status === 200) {
      data = response.data;
    }

    return data;
  } catch(err) {
    console.log(err);
  }
}

const CelebrityDetail = ({ cslExclusive24bit }) => {
  const [pageData, setPageData] = useState(null);
  const [celebrityData, setCelebrityData] = useState([]);
  const [otherCelebrityData, setOtherCelebrityData] = useState([]);
  const [songData, setSongData] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [currentSongId, setCurrentSongId] = useState(-1);
  const [currentSong, setCurrentSong] = useState(null);
  const [cuepointsData, setCuepoints] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const data = await getData();
      const celebrity = data.celebrities.filter(item => item.id === celebrityId);
      const otherCelebrity = data.celebrities.filter(item => item.id !== celebrityId);
      const songs = data.songs.filter(item => item.celebrityid === celebrityId).sort((a, b) => b.celebrityorderid - a.celebrityorderid);
      const songsWithPlaying = songs.map(item => ({ ...item, playing: false }));
      setPageData(data);
      setCelebrityData(celebrity);
      setOtherCelebrityData(otherCelebrity);
      setCurrentVideo(celebrity[0].video);
      setSongData(songsWithPlaying);
    }

    if (!pageData) {
      fetchData();
    }
    
  }, [pageData, currentSongId]);

  return (
    <Wrapper>
      <Header isRedirect />
      {!!currentVideo && (
        <StyledFullVideoPlayer 
          videoUrl={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/celebrities' : 'prod/celebrities'}/${currentVideo}`} 
          fallbackImage={{
            mobile: `${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/celebrities' : 'prod/celebrities'}/${celebrityData[0].fallbackimagemobile}`,
            desktop: `${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/celebrities' : 'prod/celebrities'}/${celebrityData[0].fallbackimagedesktop}`
          }}
        />
      )}
      {/* {!!currentVideo && <StyledVideoPlayer videoUrl={`videoplayback2.mp4`} fallbackImage={celebrityData[0].fallbackimage} />} */}
      <StyledSection bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2.jpg`} bgd={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2_d.jpg`} autoHeight>
        {Array.isArray(celebrityData) && celebrityData.map((item, index) => (
          <InfoBox key={index}>
            <br />
            {!!item.quote && item.quote !== '' && <QuoteWrapper>{item.quote}</QuoteWrapper>}
            <StyledLineHeading><span>{item.name}</span></StyledLineHeading>
            <StyledHeading>嚴選試聽 24 bit</StyledHeading>
            <Remark>建議試用耳機感受錄音室級無損音質</Remark>
          </InfoBox>
        ))}
        {!!currentSong && !(currentSong.id !== currentSongId || currentSongId === -1) ? <br /> : null}
      
      <Element name="player"><div></div></Element>
      {
        !!currentSong && (
          <GuidePlayer>
            <img className="top-deco" src={`${process.env.REACT_APP_BUILD_URL}/images/site/player/player1.png`} alt="" width="100%" />
            <GuideBox>
              <GuideInfo>
                <GuideAvatar>
                  {/* <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/${celebrityData[0].avatar}`} alt="" width="100%" /> */}
                  <img src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/audio' : 'prod/audio'}/${currentSong.cover}`} alt="" width="100%" />
                </GuideAvatar>
                <GuideInfoContent>
                  <b>{currentSong.name}</b>
                  <div className="guide-album-info">{currentSong.artist} {currentSong.album}</div>
                  <br />
                  {Array.isArray(celebrityData) && celebrityData.filter(item => item.id === currentSong.celebrityid).map((item, index) => (
                    <GuideAvatarRemark key={index}>音樂導賞由<span>{item.name}</span>提供</GuideAvatarRemark>
                  ))}
                </GuideInfoContent>
                <GuidePlay onClick={() => {
                  const songsWithPlaying = songData.map((song, index) => ({ ...song,  playing: song.id === currentSong.id ? !song.playing : false }));
                  const currentSongsWithPlaying = songsWithPlaying.filter(song => parseInt(song.id) === parseInt(currentSong.id));
                  const cuepoints = pageData.cuepoints.filter(point => parseInt(point.songid) === parseInt(currentSong.id));
                  setCurrentSongId(currentSong.id);
                  setCurrentSong(currentSongsWithPlaying[0]);
                  setSongData(songsWithPlaying);
                  setCuepoints(cuepoints);
                }}>
                  {!currentSong.playing ? <StyledPlay /> : <StyledPause />}
                </GuidePlay>
              </GuideInfo>
              <StyledHTML5Player
                cuePoints={cuepointsData}
                pageData={pageData.celebrities.filter(celebrity => celebrity.id === currentSong.celebrityid)[0]}
                currentSongData={currentSong}
                songUrl={currentSong.filename}
                playing={currentSong.playing}
                audioType="celebrities"
                hidden={currentSong.id !== currentSongId || currentSongId === -1}
              />
            </GuideBox>
            <GridBottomDecoWrapper>
              <GridBottomDeco />
            </GridBottomDecoWrapper>
          </GuidePlayer>
        )
      }
      {/* <StyledLeftHeading>嚴選試聽 24 bit</StyledLeftHeading> */}
      {Array.isArray(songData) && songData.map((item, index) => (
        <SongWrapper key={index}>
          <SongRow>
            <img src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/audio' : 'prod/audio'}/${item.cover}`} alt="" width="70" />
            <SongInfo>
              <b>{item.name}</b>
              <div className="album-info">
                <span>{item.artist}</span>
                <span>{item.album}</span>
              </div>
            </SongInfo>
            <div onClick={() => {
              if (!!unsupported) {
                setShowModal(true);
              } else {
                const songsWithPlaying = songData.map((song, index) => ({ ...song,  playing: song.id === item.id ? !song.playing : false }));
                const currentSongsWithPlaying = songsWithPlaying.filter(song => parseInt(song.id) === parseInt(item.id));
                const cuepoints = pageData.cuepoints.filter(point => parseInt(point.songid) === parseInt(item.id));
                const celebrityName = pageData.celebrities.filter(celebrity => celebrity.id === item.celebrityid)[0].name;
                setCurrentSongId(item.id);
                setCurrentSong(currentSongsWithPlaying[0]);
                setSongData(songsWithPlaying);
                setCuepoints(cuepoints);
                dataLayer.push({ event: 'CodeAudioPlayerEvent', eventAction: 'celebrities/play_song', eventLabel: `${celebrityName}/${item.name}` });

                scroller.scrollTo('player', {
                  smooth: "easeInOutQuint",
                  offset: -90
                });
              }
            }}>
              {!item.playing ? <StyledPlay /> : <PlayingLabel>播放中</PlayingLabel>}
            </div>
          </SongRow>
        </SongWrapper>
      ))}
      <StyledLeftHeading>更多音樂人導賞</StyledLeftHeading>
      <StyledSliderWrapper>
        <Slider {...settings}>
          {Array.isArray(otherCelebrityData) && otherCelebrityData.map((item, index) => (
            <OtherCelebrityAvatar
              key={index}
              href={`${process.env.REACT_APP_BASE_URL}?id=${item.id}`}
              onClick={() => {
                const celebrityName = celebrityData[0].name;
                dataLayer.push({ event: 'CodeOtherCelebritiesEvent', eventAction: 'celebrities/click_other_celebrities', eventLabel: `${celebrityName}/${item.name}` });
              }}
            >
              <div className="avatar-bg">
                <img src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/celebrities' : 'prod/celebrities'}/${item.avatar}`} alt="" width="100%" />
                {/* <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/artist1.jpg`} alt="" width="100%" /> */}
              </div>
              <AvatarInfo>
                <div className="name"><b>{item.name}</b></div>
                <div className="info">{item.title}</div>
              </AvatarInfo>
            </OtherCelebrityAvatar>
          ))}
        </Slider>
      </StyledSliderWrapper>
      <br />
      <br />
      {!!showModal && (
        <ModalWrapper>
          <ModalBox>
            <div className="mobile">
              <ModalHeading>你的瀏覽器不支援24bit音樂播放請更新或使用以下瀏覽器：</ModalHeading>
              <ModalContent><br />
                iOS Safari 11+<br />
                Android Chrome 64+<br />
              </ModalContent>
            </div>
            <div className="desktop">
              <ModalHeading>你的瀏覽器不支援24bit音樂播放請更新或使用以下瀏覽器：</ModalHeading>
              <ModalContent><br />
                Google Chrome 56+<br />
                Microsoft Edge 16+<br />
                Firefox 51+<br />
                Safari 11+*<br /><br />

                *macOS High Sierra或之後
              </ModalContent>
            </div>
            <StyledClose onClick={() => {
              setShowModal(false);
            }} />
          </ModalBox>
        </ModalWrapper>
      )}
      </StyledSection>
      <Footer cslExclusive24bit={cslExclusive24bit} />
    </Wrapper>
  );
}

export default CelebrityDetail;
